import { render, staticRenderFns } from "./GlobalMenuBtm.vue?vue&type=template&id=0d7b2a1e"
import script from "./GlobalMenuBtm.vue?vue&type=script&lang=js"
export * from "./GlobalMenuBtm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports